import { apiURLNew, callAPI, getEventId } from 'api/main';

import { middlewareMySchedule } from './middleware';

export default async (professionalId: string): Promise<IGroupedTimeSlots | null> => {
  try {
    const res = await callAPI({
      url: `${apiURLNew}/matchs/v1/schedule`,
      method: 'GET',
      needToken: true,
      isLegacy: false,
      params: {
        event_id: getEventId(),
        professional_id: professionalId,
      },
    });

    const { data } = res.request;

    if (data.schedule_open) {
      return middlewareMySchedule(data.schedule_open);
    }

    return null;
  } catch (ex) {
    return null;
  }
};
